var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E21A20",
    d: "M35 0L5 0C2.2425001 0 0 2.2425001 0 5L0 35C0 37.7575 2.2425001 40 5 40L35 40C37.7575 40 40 37.7575 40 35L40 5C40 2.2425001 37.7575 0 35 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    transform: "translate(9.06036 12.1871)",
    d: "M21.758389 4.6629338C21.605265 2.5535586 21.22089 0.37543362 18.524014 0.21605863C13.470825 -0.072019547 8.4053288 -0.072019547 3.3521395 0.21605863C0.65526438 0.37230864 0.27088937 2.5535586 0.11776437 4.6629338C-0.039254788 6.7599983 -0.039254788 8.8658686 0.11776437 10.962934C0.27088937 13.072309 0.65526438 15.250434 3.3521395 15.409808C8.4053288 15.697886 13.470825 15.697886 18.524014 15.409808C21.22089 15.253558 21.605265 13.072309 21.758389 10.962934C21.915409 8.8658686 21.915409 6.7599983 21.758389 4.6629338L21.758389 4.6629338ZM8.7521391 10.625434L8.7521391 4.3754334L14.689639 7.5004334L8.7521391 10.625434Z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.3ecf301272ea373d53ac513318bf4727.svg";
export { ForwardRef as ReactComponent };